import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cta: 'See what’s wrong',
    help: 'Contact us',
    subtitle: 'We couldn’t validate your account',
    title: 'Your account is locked',
  },
  fr: {
    cta: 'Voir ce qui ne va pas',
    help: 'Nous contacter',
    subtitle: 'Nous n’avons pas pu valider votre compte',
    title: 'Votre compte est bloqué',
  },
});
